import React, { useEffect } from 'react';
import MaterialTable, { MaterialTableProps } from 'material-table';
import {Box, Breadcrumbs, Button, Typography} from '@material-ui/core';
import {withRouter, RouteComponentProps, Link} from 'react-router-dom';

import { useStudentPerspective } from '../../../../../context/StudentPerspective';
import AdminLayout from '../../../../../layouts/AdminLayout';
import Course from '../../../../../models/Course';

const Courses = (props: RouteComponentProps<{student_id: string}>) => {
  const {student_id: studentId} = props.match.params;
  const {
    loadData,
    getStudentCourses,
    getStudentById,
    isLoading,
    errorMessage
  } = useStudentPerspective();

  const student = getStudentById(studentId);

  const studentCourses = getStudentCourses(studentId);

  const tableProps: MaterialTableProps<Course> = {
    title: (
      <Box pt={2}>
        <Typography variant="h5">Courses</Typography>
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/admin/students">Students</Link>
          <Typography>{student?.fullName || studentId}</Typography>
          <Typography>Courses</Typography>
        </Breadcrumbs>
      </Box>
    ),
    data: studentCourses,
    isLoading,
    columns: [
      {
        title: 'Course ID',
        field: 'id'
      },
      {
        title: 'Name',
        field: 'name',
        defaultSort: 'asc'
      }
    ],
    localization: {
      body: {
        emptyDataSourceMessage: 'No Course/s Found.'
      }
    },
    options: {
      headerStyle: {
        fontWeight: 'bold'
      },
      pageSize: 10,
      pageSizeOptions: [5, 10, 20, 50],
      emptyRowsWhenPaging: false,
      search: true,
      sorting: true,
      draggable: false,
      thirdSortClick: false
    },
    onRowClick: (event, course) => {
      if (course)
        props.history.push(`/admin/students/${studentId}/courses/${course.id}/assignments`);
    }
  };

  useEffect(() => {
    (async () => await loadData())();
  }, []);

  return (
    <AdminLayout>
      <div className="p-4">
        {(() => {
          if (errorMessage)
            return (
              <div className="text-center">
                <h2 className="m-0">Error Loading Courses</h2>
                <p>{errorMessage}</p>
                <Button
                  type="button"
                  onClick={loadData}
                  color="primary"
                  className="mt-3"
                  variant="contained">
                  Try Again
                </Button>
              </div>
            );

          return (<MaterialTable {...tableProps} />);
        })()}
      </div>
    </AdminLayout>
  );
};

export default withRouter(Courses);
